import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '../../theming/ThemeProvider'
import { View } from 'react-native'
import { usePlatforms } from '../../hooks/usePlatforms'
import { useFiltersContaientStyles as useStyles } from './styles'
import { Menu, Button, IconButton, Icon, Txt } from '..'
import SearchByOrderNumber from './SearchByOrderNumber'
import FiltersModal from './FiltersModal'

const FiltersContainer = ({
  children, modalRef, onClose, orderNumberFilter, initOrderNumber, handleSearch, handleClearFilters, handleSearchOrderNumber
}) => {
  const { theme } = useTheme()
  const { isDesktop } = usePlatforms()
  const styles = useStyles(theme, isDesktop)
  const [openOrderNumberSearch, setOpenOrderNumberSearch] = useState(false)

  const menuItems = [{ text: 'Clear filters', fn: handleClearFilters }]
  const menuItemsWithSearchOrderNumber = [...menuItems, {
    text: 'Search Order Number',
    fn: () => setOpenOrderNumberSearch(true)
  }]

  return (
    <FiltersModal
      ref={modalRef}
      onClose={onClose}
      isDesktop={isDesktop}
    >
      <View style={[styles.filters, isDesktop && styles.largeFilters]}>
        <View style={[styles.firstSection, isDesktop && styles.firstSectionDesk]}>
          {!isDesktop && (
            <Txt
              text='Filters'
              identity='body2Bold'
            />
          )}
          {children}
        </View>
        <View style={styles.buttons}>
          {isDesktop ? (
            <>
              <View>
                <IconButton
                  icon='FilterSearch'
                  size={30}
                  iconSize={13}
                  onPress={handleSearch}
                  color='AZTEC'
                  testID='filtersSearchButton'
                  accessibilityLabel='filtersSearchButton'
                />
              </View>
              <View>
                <Menu items={isDesktop && orderNumberFilter ? menuItemsWithSearchOrderNumber : menuItems}>
                  <View style={styles.options}>
                    <Icon
                      name='ShowMore'
                      width={10}
                      height={16}
                      fill={theme.SLATE_GRAY}
                    />
                  </View>
                </Menu>
              </View>
            </>
          )
            : (
              <View style={{ flex: 1 }}>
                <Button
                  title='Search'
                  onPress={handleSearch}
                  testID='filtersSearchButton'
                  accessibilityLabel='filtersSearchButton'
                />
              </View>
            )}
        </View>
      </View>
      {isDesktop && openOrderNumberSearch && orderNumberFilter && (
        <SearchByOrderNumber
          initialValue={initOrderNumber}
          handleSearch={handleSearchOrderNumber}
          onClose={() => setOpenOrderNumberSearch(false)}
        />
      )}
    </FiltersModal>
  )
}

FiltersContainer.propTypes = {
  children: PropTypes.node.isRequired,
  modalRef: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  orderNumberFilter: PropTypes.bool,
  handleSearchOrderNumber: PropTypes.func,
  initOrderNumber: PropTypes.string
}

export default FiltersContainer
